module.exports = __webpack_public_path__ + "img/ic_extract.26154439.svg";